export default __webpack_public_path__ + "615f37c94202eb440c72b45237114c19.png";